module.exports = __webpack_public_path__ + "static/media/loginMbanner.e707d9e0.svg";